import React from "react";
import KC_Colors from "../KC_Colors";
import { classNameForColor, getHeight, KC_Sizes } from "../ds_commons";
import "./styles.scss";
import { separatorSizesMap } from "./utils";

interface PropsI {
  color?: KC_Colors;
  thickness?: number;
  hasLine?: boolean;
  size?: KC_Sizes;
  text?: string;
  className?: string;
}

const KC_Divider = ({
  color = KC_Colors.Blue,
  thickness = 1,
  size = KC_Sizes.m,
  hasLine = false,
  className
}: PropsI) => {
  return (
    <div className={`kc-separator__container ${className}`}>
      <div
        className={`kc-separator__separator ${
          hasLine ? classNameForColor(color) : ""
        }`}
        style={{
          height: getHeight(size, separatorSizesMap),
          borderBottom: hasLine ? `${thickness}px solid` : "none",
          borderBottomColor: "inherit"
        }}
      >
        &nbsp;
      </div>
    </div>
  );
};

export default KC_Divider;
